export default {
  title: 'Components/Checkbox',
  tags: ['autodocs'],
  argTypes: {
    title_text: {
      control: 'text',
      description: 'Title for the checkbox',
    },
    supporting: {
      control: 'text',
      description: 'Supporting text for the checkbox',
    },
    group_name: {
      control: 'text',
      description: 'Name for checkbox group',
    },
    input_id: {
      control: 'text',
      description: 'Unique ID for the input field',
    },
    checked: {
      control: 'boolean',
      description: 'Checked state of the checkbox',
    },
    checkbox_status: {
      control: { type: 'select' },
      options: ['normal', 'disabled'],
      description: 'Visual status indicator',
    },
    style_type: {
      control: { type: 'select' },
      options: ['fill', 'stroke'],
      description: 'Visual style of the checkbox',
    },
    custom_class: {
      control: { type: 'text' },
      description: 'Additional CSS classes',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the checkbox component',
    },
    aria_label: {
      control: { type: 'text' },
      description: 'ARIA label for accessibility',
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-checkbox\` component, pass the following props:

\`\`\`html
<dda-checkbox
    title_text="Checkbox Title"
    checked="false"
    style_type="fill"
    supporting="Supporting Text"
    group_name="checkboxgroup"
    input_id="testId"
    custom_class=""
    component_mode=""
    aria_label="checkbox"
></dda-checkbox>

<!-- Listen for checkboxChange event -->
<script>
  document.querySelector('dda-checkbox').addEventListener('checkboxChange', e => {
    console.log('Checkbox toggled:', e.detail);
  });
</script>
\`\`\`
        `,
      },
    },
  },
};

const Template = (args) => {
  const uniqueId = args.input_id || 'checkbox-demo-id';

  // Create checkbox markup
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  // Return wrapped HTML with event binding
  return `
      <dda-checkbox ${attributes}></dda-checkbox>
      <script>
        (() => {
          const checkbox = document.getElementById("checkbox-${uniqueId}");
          if (checkbox) {
            checkbox.addEventListener("checkboxChange", function(e) {
              console.log("Checkbox [${uniqueId}] changed to:", e.detail);
            });
          }
        })();
      </script>
  `;
};

export const checkbox = Template.bind({});
checkbox.args = {
  title_text: 'Checkbox Title',
  checked: false,
  style_type: 'fill',
  supporting: 'Supporting Text',
  group_name: 'checkboxgroup',
  input_id: 'checkboxOne',
  aria_label: 'checkbox',
  custom_class: '',
  component_mode: '',
  checkbox_status: 'normal',
  checkboxChange:"",
};

